/**
 * 常用工具类
 */
const client = require("./client.js"); // 签名
module.exports = {
  client: client.Client,
};